import React, {ReactNode, useCallback} from 'react';
import {ModelDTO} from 'hemwb-api';
import {ModelFileUploaded, ModelTreeNode, useModelFileUploader} from '../../../../../store/modelFile';
import FileTreeAntd from '../../../../core/FileTree/FileTreeAntd';

export type ModelEditFileTypesProps = {
  model: ModelDTO;
  files?: ModelTreeNode[];
  onChange?: (updatedModel: ModelDTO, updatedFiles: ModelTreeNode[]) => void;
  onSubmit: (updatedModel: ModelDTO, updatedFiles: ModelTreeNode[]) => void;
  buttons: () => string | ReactNode;
  createFlow?: boolean;
  uploadFlow?: boolean;
  cloneFileTypeFlow?: boolean;
  unSelectAll?: boolean;
};

const ModelEditFileTypes: React.FC<ModelEditFileTypesProps> = ({model, files}) => {
  const {markForFileTag, uploader} = useModelFileUploader(model, files);
  const filteredFileUuids = new Set(files?.map((f) => f.uuid));
  const nodes = files ? uploader.nodes.filter((n) => filteredFileUuids.has(n.uuid) || !n.uploaded) : uploader.nodes;

  const handleFileTag = useCallback(
    (node: ModelFileUploaded, fileTag: string) => {
      markForFileTag(node, fileTag);
    },
    [markForFileTag],
  );

  return (
    <div>
      {nodes && nodes.length > 0 && (
        <FileTreeAntd files={nodes} createFlow={true} cloneFlow={true} handleFileTag={handleFileTag} />
      )}
    </div>
  );
};

export default ModelEditFileTypes;
